function isValidHttpUrl(value) {
   const url = String(value || '').trim();
   return /^https?:\/\//i.test(url);
}

export function getStripeCheckoutUrl() {
   const url = process.env.NEXT_PUBLIC_STRIPE_PAYMENT_URL || process.env.NEXT_PUBLIC_STRIPE_PAYMENT_LINK || '';
   return String(url).trim();
}

async function resolveCheckoutUrl({
   campaignTag = 'vertex',
   originPath = '/campaign/vertex',
   checkoutType = 'bulk',
   itemName,
   itemId,
} = {}) {
   const staticUrl = getStripeCheckoutUrl();
   if (isValidHttpUrl(staticUrl)) {
      return { success: true, url: staticUrl };
   }

   const response = await fetch('/api/stripe/checkout-session', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ campaignTag, originPath, checkoutType, itemName, itemId }),
   });

   const data = await response.json().catch(() => ({}));
   if (!response.ok) {
      return { success: false, error: data?.error || 'Could not create Stripe checkout session.' };
   }

   if (!isValidHttpUrl(data?.url)) {
      return { success: false, error: 'Stripe checkout URL is invalid.' };
   }

   return { success: true, url: data.url };
}

export async function openExternalCheckout({
   campaignTag = 'vertex',
   originPath = '/campaign/vertex',
   checkoutType = 'bulk',
   itemName,
   itemId,
} = {}) {
   const resolved = await resolveCheckoutUrl({ campaignTag, originPath, checkoutType, itemName, itemId });
   if (!resolved.success) {
      return resolved;
   }

   // Use a single navigation path to avoid opening multiple tabs/windows.
   window.location.assign(resolved.url);

   return { success: true };
}
